import type Quill from 'quill/core';
import { Delta } from 'quill/core';
import QuillClipboard from 'quill/modules/clipboard';
import type CodeEmbed from '../formats/CodeEmbed';
import type { Range } from '../types';

class CodeEmbedEditorClipboard extends QuillClipboard {
  blot: CodeEmbed;

  constructor(quill: Quill, { blot }: { blot: CodeEmbed }) {
    super(quill, { matchers: [] });
    this.blot = blot;
  }

  onCopy(range: Range) {
    return { html: this.blot.html(range), text: this.blot.code(range) };
  }

  // eslint-disable-next-line class-methods-use-this
  convert({ text }: { text?: string }) {
    return new Delta().insert(text || '');
  }
}

export default CodeEmbedEditorClipboard;
